import { GuestSelectors, UserSelectors } from '@recruitee/account-data';
import type {
  HiddenResultPreview,
  InterviewResultsReferences,
} from '@recruitee/interview-results-types';
import { createEntityCollectionStore, DEFAULT_SCOPE_NAME, pipeState } from '@recruitee/ngrx';
import { JobsBriefSelectors, StageSelectors } from '@recruitee/offers-data';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<HiddenResultPreview>()('InterviewResultsHiddenPreview', {
    references: makeRef => [
      makeRef('guestIds', 'guests', GuestSelectors.byIds),
      makeRef('adminIds', 'admins', UserSelectors.byIds),
      makeRef('offerId', 'offer', JobsBriefSelectors.byId),
      makeRef('stageId', 'stage', (stageId: number) => StageSelectors.byId(stageId)),
    ],

    // eslint-disable-next-line max-lines-per-function
    customActions: adapter => ({
      fetchCollection: (
        state,
        payload: {
          data: HiddenResultPreview[];
          references: InterviewResultsReferences[];
          scope: string;
          replace?: boolean;
        },
      ) =>
        pipeState(
          state,
          next => (payload.replace ? adapter.resetAll(next) : next),
          next =>
            adapter.markAsPending(next, {
              scope: payload.scope || DEFAULT_SCOPE_NAME,
              entities: [],
            }),
        ),
      fetchCollectionSuccess: (
        state,
        payload: {
          data: HiddenResultPreview[];
          references: InterviewResultsReferences[];
          scope: string;
          replace?: boolean;
        },
      ) =>
        pipeState(
          state,
          next => (payload.replace ? adapter.setMany(next, [], { scope: payload.scope }) : next),
          next => adapter.setMany(next, payload.data, { scope: payload.scope }),
          next =>
            adapter.markAsLoaded(next, {
              scope: payload.scope || DEFAULT_SCOPE_NAME,
              entities: payload.data.map(entity => entity.id),
            }),
        ),
    }),
  });

export {
  actions as InterviewResultsHiddenPreviewActions,
  selectors as InterviewResultsHiddenPreviewSelectors,
  reducer as InterviewResultsHiddenPreviewReducer,
  namespace as InterviewResultsHiddenPreviewNamespace,
};
